/*
 * BBC - Rap Map - Map custom pop ups
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React, { useEffect, useRef } from 'react';
import { Popup } from 'react-map-gl';
import CloseButton from "./CloseButton";

const CustomPopup = ({
    marker,
    closePopup,
    setVideo,
    season,
    rapperOfTheWeek
}) => {
    const {
        geometry: {
            coordinates,
        },
        name,
        id,
        location,
        image_url: imageURL,
        video_pid: videoPID,
        soundcloud,
        youtube,
    } = marker[0];
    const [longitude, latitude] = coordinates;
    const popupRef = useRef();
    const imagePath = `https://ichef.bbci.co.uk/images/ic/480xn/${imageURL}.jpg`;
    const isRapperOfTheWeek = rapperOfTheWeek?.id === id;

    useEffect(() => {
        if (id !== undefined && id !== "undefined") {
            window.history.pushState(
                null,
                null,
                `${window.location.origin}${window.location.pathname}?v=${id}&season=${season}`
            );
        }
    }, [id, season]);

    useEffect(() => {
        if (popupRef.current) {
            // better tab order for screen readers
            popupRef.current.focus();
        }
    }, [popupRef]);

    const keydownListener = e => {
        if (e.code === 'Escape') {
            closePopup();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', keydownListener, true);
        return () => window.removeEventListener('keydown', keydownListener, true);
        // eslint-disable-next-line
    }, []);

    return (
        <Popup
            className={`Map__Popup ${isRapperOfTheWeek ? 'Map__Popup--rapperOfTheWeek' : ''}`}
            latitude={latitude}
            longitude={longitude}
            onClose={closePopup}
            closeButton={false}
            closeOnClick={false}
            offsetTop={-20}
            anchor="bottom"
            dynamicPosition={false}
        >
            <div className="Map__Popup-head" tabIndex="1">
                <h2 className="vh">Rapper pop-up</h2>
                <CloseButton onClick={closePopup} ariaText="Close Popup" />
                {imageURL
                    ? (
                        <div className="Map__Popup-images">
                            <div className="Map__Popup-image" style={{ backgroundImage: `url(${imagePath})` }} />
                            <div className="Map__Popup-image--blur" style={{ backgroundImage: `url(${imagePath})` }} />
                            {videoPID?.length > 0
                                ? <button
                                    className="Map__Popup-video"
                                    onClick={() => setVideo(marker[0])}
                                    autoFocus
                                >
                                    Watch Video
                                </button>
                                : ''
                            }
                        </div>
                    )
                    : ''
                }
                <div className="Map__Popup-headinfo">
                    <div className="Map__Popup-headinfo_top">
                        <p className="Map__Popup-name">{name}</p>
                        <p className="Map__Popup-location">{location}</p>
                        <div className="Map__Popup-socials">
                            {youtube
                                ? <a
                                    href={youtube}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`Map__Popup-socials-social Map__Popup-socials--youtube`}
                                    style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/assets/social-youtube.png')` }}
                                >
                                    <span className="vh">
                                        YouTube
                                    </span>
                                </a>
                                : ''
                            }
                            {soundcloud
                                ? <a
                                    href={soundcloud}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`Map__Popup-socials-social Map__Popup-socials--soundcloud`}
                                    style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/assets/social-soundcloud.png')` }}
                                >
                                    <span className="vh">
                                        Sound Cloud
                                    </span>
                                </a>
                                : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    )
};

export default CustomPopup;
